import React from 'react';
import { Typography, Stack, Box } from '@mui/material';
import { School as SchoolIcon } from '@mui/icons-material';
import { IEducation } from './types';

export default function EducationItem({ education }: { education: IEducation }) {
  const degrees = education.degree || [];
  const degreesWithFaculty = [...degrees, education.faculty].filter(Boolean).join(', ');

  return (
    <Stack direction="row" spacing={1}>
      <Box
        sx={{
          padding: '8px',
          height: '44px',
          border: '1px solid #E3E3E3',
          background: '#ffffff',
          zIndex: 1
        }}
      >
        <SchoolIcon sx={{ height: '24px', width: '24px' }} />
      </Box>
      <Stack direction="column" spacing={2} sx={{ flex: 1, minWidth: 0 }}>
        <Stack direction="column" spacing={1} sx={{ width: '100%' }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="column">
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {education.university}
              </Typography>
              <Typography variant="body2">{degreesWithFaculty}</Typography>
            </Stack>
            {education.startedYear ? (
              <Typography variant="body2" sx={{ color: '#858585' }}>
                <span>{education.startedYear}</span>
                <span>{' - '}</span>
                <span>{education.endedYear || 'Present'}</span>
              </Typography>
            ) : (
              <div />
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
